import React from 'react'
import "../../Others/DMC/Contracts/Status/completed.css"
const Completed = () => {
    return (
            <div className="completed-wrapper d-flex align-items-end justify-content-center">
                <p className="lead text-center">NO SERVICES YET</p>
            </div>
    )
}
export default Completed
